// extracted by mini-css-extract-plugin
module.exports = {"homePage":"bdsa8Yt","homePageLeft":"_5vBCefF","homePageRight":"_2hpwjn5","homePageTimetable":"_7fZ0Cvy","linksCard":"_5cClua8","homeLinkContainer":"vpjkAUI"};